import { parseISO } from 'date-fns';

export enum CpUserType {
  player = 'p',
  merchant = 'm',
  terminal = 't'
}

export enum CpUserLicenseKind {
  default = 'mof', // lvbetp
  ukgc = 'ukgc', // lvbetcom ukgc
  iaui = 'iaui', // lvbetlv
  mga = 'mga' // lvbetcom rest of the world
}

export type CpUserInfo = {
  readonly status: 'logged' | 'not_logged';
  readonly countryCode: string;
  readonly sessionId: string;
  readonly countryIp: string;
  readonly currency: string;
  readonly login: string;
  readonly firstName: string;
  readonly isUserAccountFullRegistered: boolean;
  readonly userType: CpUserType;
  readonly isTemporaryAccount: boolean;
  readonly termsVersion: string;
  readonly affiliateId: string;
  readonly userLicenseKind: CpUserLicenseKind;
  readonly userId: number;
  readonly lastLoginAt: Date | undefined;
  readonly canTake24BreakViaRealityCheck: boolean;
  readonly isVip: boolean;
  readonly isEmailVerified: boolean;
  readonly registeredViaAuthologic: boolean;
  readonly registeredViaOneStep: boolean;
  readonly pnpPendingTransactionRef: string;
  readonly _type: '_userInfo';
};

export function isCpUserInfo(input: any): input is CpUserInfo {
  return input?.['_type'] === '_userInfo';
}

export function createTestingCpUserInfoPartial(partial: Partial<CpUserInfo>): CpUserInfo {
  return {
    ...partial,
    _type: '_userInfo'
  } as CpUserInfo;
}

export function createCpUserInfoFromHttpJson(json: Record<string, any>): CpUserInfo {
  return {
    status: json['status'],
    countryCode: json['country'],
    sessionId: json['session'],
    countryIp: json['country_ip'],
    currency: json['currency'],
    login: json['login'],
    firstName: json['first_name'],
    isUserAccountFullRegistered: json['is_full_data'],
    userType: json['user_type'],
    isTemporaryAccount: json['temporary_account'],
    termsVersion: json['terms_version'],
    affiliateId: json['affiliate_id'] ?? '',
    userLicenseKind: json['rg_license_type'],
    userId: json['id'],
    lastLoginAt: json['last_login'] ? parseISO(json['last_login']) : undefined,
    canTake24BreakViaRealityCheck: json['can_be_block_via_reality_check_popup'] === true,
    isVip: json['is_special_user'],
    isEmailVerified: json['email_verified'],
    registeredViaAuthologic: json['registered_via_authologic'],
    registeredViaOneStep: json['registered_via_one_step'],
    pnpPendingTransactionRef: json['pending_pnp_transaction'],
    _type: '_userInfo'
  };
}
